// extracted by mini-css-extract-plugin
export default {"rich-text-editor":"RichTextEditor_rich-text-editor__jCalA","editor-container":"RichTextEditor_editor-container__y1+Qk"};